(function() {
  var qs = window.MidYearSaleUtils.qs;
  var qsa = window.MidYearSaleUtils.qsa;

  function initTimelineProgress(root) {
    var bar = qs(root, '[data-mys-timeline]');
    if (!bar) return;
    var start = new Date(bar.dataset.start || '').getTime();
    var end = new Date(bar.dataset.end || '').getTime();
    if (!start || !end || end <= start) return;

    function update() {
      var now = Date.now();
      var progress = ((now - start) / (end - start)) * 100;
      progress = Math.max(0, Math.min(100, progress));
      bar.style.setProperty('--mys-timeline-progress', progress.toFixed(2) + '%');
    }

    update();
    window.setInterval(update, 60000);
  }

  function boot(root) {
    qsa(root, '[data-mid-year-sale]').forEach(function(section) {
      if (section.dataset.boundCalendar === 'true') return;
      section.dataset.boundCalendar = 'true';
      initTimelineProgress(section);
    });
  }

  function init() {
    boot(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(event) {
    if (!event.detail || !event.detail.sectionId) return;
    var section = document.getElementById('shopify-section-' + event.detail.sectionId);
    if (section) boot(section);
  });
})();
